import moment from 'moment'

export default {

    async mount(vue) {
        vue.$config = {
            api: process.env.VUE_APP_API
        }
        vue.$api.defaults.baseURL = vue.$config.api
        moment.locale(['fr-ch', 'fr'])
        return vue.$config
    }
}
